import {IComponentOptions, ILogService} from "angular";
import "./application-history.less";

class ApplicationHistoryController {

    public applicationHistories: any[];
    public mostRecentHistory;

    /* @ngInject */
    constructor(private $log: ILogService) {
    }

    public $onInit() {
        this.$log.debug(this.applicationHistories);
    }

    public $onChanges(changesObj) {
        this.$log.debug("$onChanges", changesObj);
        if (changesObj.applicationHistories) {
            this.mostRecentHistory = this.getMostRecentHistory(changesObj.applicationHistories.currentValue);
        }
    }

    private getMostRecentHistory(applicationHistories: any[]) {
        if (!applicationHistories || applicationHistories.length <= 0) {
            return null;
        }

        return applicationHistories[applicationHistories.length - 1];
    }

}

export const ApplicationHistoryComponent: IComponentOptions = {
    bindings: {
        applicationHistories: "<"
    },
    controller: ApplicationHistoryController,
    template: require("./application-history.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/application/history/application-history.component.ts